import ResponsiveImage from '~/components/Image/ResponsiveImage'
import LoaderSkeleton from '~/shared/components/LoaderSkeleton'

interface Props {
  isLoading?: boolean
  imgAlt?: string
  imgSrcKey: string
  title: string
  result: React.ReactNode
  height?: number
  width?: number
}

const mediaQuery = [{ screen: '(min-width: 280px)', width: '24px' }]

export default function AchievementItem({
  isLoading = false,
  imgAlt = '',
  imgSrcKey,
  title,
  result,
  height = 24,
  width = 24,
}: Props): React.ReactElement {
  return (
    <div className="flex justify-between">
      <div className="flex items-center space-x-3">
        <ResponsiveImage
          alt={imgAlt}
          height={height}
          imageWidths={`${width}`}
          mediaQuery={mediaQuery}
          srcKey={imgSrcKey}
          width={width}
        />
        <p>{title}</p>
      </div>
      {!isLoading && <div className="font-semibold">{result}</div>}
      {isLoading && <LoaderSkeleton className="h-5 w-20 rounded-1" />}
    </div>
  )
}
